var __templateData = Handlebars.template({"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    return "<h2>\r\n  Liste des Pays\r\n  <button rel=\"tooltip\" data-title=\"Ajouter une pays\" id=\"btn-show-form-pays\" type=\"button\" class=\"btn btn-outline btn-xs btn-icon fa fa-plus btn-success pull-right\"></button>\r\n</h2>\r\n<div id=\"pays-form-ctn\"></div>\r\n<form id=\"form-pagination\">\r\n  <div id=\"pays-list\">\r\n    <i class=\"fa fa-refresh fa-spin\"></i> Chargement en cours...\r\n  </div>\r\n  <input type=\"hidden\" name=\"tri\" id=\"tri-ui\" value=\"pays\" />\r\n  <input type=\"hidden\" name=\"trid\" id=\"trid-ui\" value=\"asc\" />\r\n</form>\r\n";
},"useData":true});
if (typeof define === 'function' && define.amd) {
  define([], function() {
    return __templateData;
  });
} else if (typeof module === 'object' && module && module.exports) {
  module.exports = __templateData;
} else {
  __templateData;
}